import { Job } from './Job'
export class FbaJob extends Job {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaJob'
  }
  get subTenantId() {
    return this._data.subTenantId
  }
  set subTenantId(subTenantId) {
    this._data.subTenantId = subTenantId || 0
  }
  get bookingNo() {
    return this._data.bookingNo
  }
  set bookingNo(bookingNo) {
    this._data.bookingNo = bookingNo
  }
  get containerLoadType() {
    return this._data.containerLoadType
  }
  set containerLoadType(containerLoadType) {
    this._data.containerLoadType = containerLoadType
  }
  get electric() {
    return this._data.electric
  }
  set electric(electric) {
    this._data.electric = electric || false
  }
  get magnetic() {
    return this._data.magnetic
  }
  set magnetic(magnetic) {
    this._data.magnetic = magnetic || false
  }
  get powdery() {
    return this._data.powdery
  }
  set powdery(powdery) {
    this._data.powdery = powdery || false
  }
  get liquid() {
    return this._data.liquid
  }
  set liquid(liquid) {
    this._data.liquid = liquid || false
  }
  get domesticWarehouse() {
    return this._data.domesticWarehouse
  }
  set domesticWarehouse(domesticWarehouse) {
    this._data.domesticWarehouse = domesticWarehouse
  }
  get preAmazonWhTime() {
    return this._data.preAmazonWhTime
  }
  set preAmazonWhTime(preAmazonWhTime) {
    this._data.preAmazonWhTime = preAmazonWhTime
  }
  get serviceChannel() {
    return this._data.serviceChannel
  }
  set serviceChannel(serviceChannel) {
    this._data.serviceChannel = serviceChannel
  }
  get warehouseCode() {
    return this._data.warehouseCode
  }
  set warehouseCode(warehouseCode) {
    this._data.warehouseCode = warehouseCode
  }
  get remoteWarehouse() {
    return this._data.remoteWarehouse
  }
  set remoteWarehouse(remoteWarehouse) {
    this._data.remoteWarehouse = remoteWarehouse || false
  }
  get country() {
    return this._data.country
  }
  set country(country) {
    this._data.country = country
  }
  get zipCode() {
    return this._data.zipCode
  }
  set zipCode(zipCode) {
    this._data.zipCode = zipCode
  }
  get shippingType() {
    return this._data.shippingType
  }
  set shippingType(shippingType) {
    this._data.shippingType = shippingType
  }
  get destinationDistribution() {
    return this._data.destinationDistribution
  }
  set destinationDistribution(destinationDistribution) {
    this._data.destinationDistribution = destinationDistribution || '0'
  }
  get expressCompany() {
    return this._data.expressCompany
  }
  set expressCompany(expressCompany) {
    this._data.expressCompany = expressCompany
  }
  get expressNo() {
    return this._data.expressNo
  }
  set expressNo(expressNo) {
    this._data.expressNo = expressNo
  }
  get customsMethodPol() {
    return this._data.customsMethodPol
  }
  set customsMethodPol(customsMethodPol) {
    this._data.customsMethodPol = customsMethodPol
  }
  get customsMethodPod() {
    return this._data.customsMethodPod
  }
  set customsMethodPod(customsMethodPod) {
    this._data.customsMethodPod = customsMethodPod
  }
  get incoTerm() {
    return this._data.incoTerm
  }
  set incoTerm(incoTerm) {
    this._data.incoTerm = incoTerm
  }
  get poNumber() {
    return this._data.poNumber
  }
  set poNumber(poNumber) {
    this._data.poNumber = poNumber
  }
  get shipmentId() {
    return this._data.shipmentId
  }
  set shipmentId(shipmentId) {
    this._data.shipmentId = shipmentId
  }
  get referenceId() {
    return this._data.referenceId
  }
  set referenceId(referenceId) {
    this._data.referenceId = referenceId
  }
  get chargingMethod() {
    return this._data.chargingMethod
  }
  set chargingMethod(chargingMethod) {
    this._data.chargingMethod = chargingMethod || '0'
  }
  get valueAddedServices() {
    return this._data.valueAddedServices
  }
  set valueAddedServices(valueAddedServices) {
    this._data.valueAddedServices = valueAddedServices
  }
  get eoriNo() {
    return this._data.eoriNo
  }
  set eoriNo(eoriNo) {
    this._data.eoriNo = eoriNo
  }
  get vatNoType() {
    return this._data.vatNoType
  }
  set vatNoType(vatNoType) {
    this._data.vatNoType = vatNoType
  }
  get vatNo() {
    return this._data.vatNo
  }
  set vatNo(vatNo) {
    this._data.vatNo = vatNo
  }
  get taxRegisterCountry() {
    return this._data.taxRegisterCountry
  }
  set taxRegisterCountry(taxRegisterCountry) {
    this._data.taxRegisterCountry = taxRegisterCountry
  }
  get taxRegisterAddress() {
    return this._data.taxRegisterAddress
  }
  set taxRegisterAddress(taxRegisterAddress) {
    this._data.taxRegisterAddress = taxRegisterAddress
  }
  get taxCompany() {
    return this._data.taxCompany
  }
  set taxCompany(taxCompany) {
    this._data.taxCompany = taxCompany
  }
  get preWarehousingTime() {
    return this._data.preWarehousingTime
  }
  set preWarehousingTime(preWarehousingTime) {
    this._data.preWarehousingTime = preWarehousingTime
  }
  get quantityContract() {
    return this._data.quantityContract
  }
  set quantityContract(quantityContract) {
    this._data.quantityContract = quantityContract || 0
  }
  get weightContract() {
    return this._data.weightContract
  }
  set weightContract(weightContract) {
    this._data.weightContract = weightContract || 0
  }
  get cubageContract() {
    return this._data.cubageContract
  }
  set cubageContract(cubageContract) {
    this._data.cubageContract = cubageContract || 0
  }
  get quantityActual() {
    return this._data.quantityActual
  }
  set quantityActual(quantityActual) {
    this._data.quantityActual = quantityActual || 0
  }
  get weightActual() {
    return this._data.weightActual
  }
  set weightActual(weightActual) {
    this._data.weightActual = weightActual || 0
  }
  get cubageActual() {
    return this._data.cubageActual
  }
  set cubageActual(cubageActual) {
    this._data.cubageActual = cubageActual || 0
  }
  get quantityCharge() {
    return this._data.quantityCharge
  }
  set quantityCharge(quantityCharge) {
    this._data.quantityCharge = quantityCharge || 0
  }
  get weightCharge() {
    return this._data.weightCharge
  }
  set weightCharge(weightCharge) {
    this._data.weightCharge = weightCharge || 0
  }
  get cubageCharge() {
    return this._data.cubageCharge
  }
  set cubageCharge(cubageCharge) {
    this._data.cubageCharge = cubageCharge || 0
  }
  get bubbleCountingRatio() {
    return this._data.bubbleCountingRatio
  }
  set bubbleCountingRatio(bubbleCountingRatio) {
    this._data.bubbleCountingRatio = bubbleCountingRatio || 0
  }
  get bubbleSplittingRatio() {
    return this._data.bubbleSplittingRatio
  }
  set bubbleSplittingRatio(bubbleSplittingRatio) {
    this._data.bubbleSplittingRatio = bubbleSplittingRatio || 0
  }
  get pickupService() {
    return this._data.pickupService
  }
  set pickupService(pickupService) {
    this._data.pickupService = pickupService || false
  }
  get pickupTime() {
    return this._data.pickupTime
  }
  set pickupTime(pickupTime) {
    this._data.pickupTime = pickupTime
  }
  get pickupDoor() {
    return this._data.pickupDoor
  }
  set pickupDoor(pickupDoor) {
    this._data.pickupDoor = pickupDoor
  }
  get doorMan() {
    return this._data.doorMan
  }
  set doorMan(doorMan) {
    this._data.doorMan = doorMan
  }
  get doorManTel() {
    return this._data.doorManTel
  }
  set doorManTel(doorManTel) {
    this._data.doorManTel = doorManTel
  }
  get doorAddress() {
    return this._data.doorAddress
  }
  set doorAddress(doorAddress) {
    this._data.doorAddress = doorAddress
  }
  get customerRequire() {
    return this._data.customerRequire
  }
  set customerRequire(customerRequire) {
    this._data.customerRequire = customerRequire
  }
  get submitState() {
    return this._data.submitState
  }
  set submitState(submitState) {
    this._data.submitState = submitState
  }
  get submitBy() {
    return this._data.submitBy
  }
  set submitBy(submitBy) {
    this._data.submitBy = submitBy
  }
  get submitDate() {
    return this._data.submitDate
  }
  set submitDate(submitDate) {
    this._data.submitDate = submitDate
  }
  get verifyState() {
    return this._data.verifyState
  }
  set verifyState(verifyState) {
    this._data.verifyState = verifyState
  }
  get verifyBy() {
    return this._data.verifyBy
  }
  set verifyBy(verifyBy) {
    this._data.verifyBy = verifyBy
  }
  get verifyDate() {
    return this._data.verifyDate
  }
  set verifyDate(verifyDate) {
    this._data.verifyDate = verifyDate
  }
  get verifyRefuseReason() {
    return this._data.verifyRefuseReason
  }
  set verifyRefuseReason(verifyRefuseReason) {
    this._data.verifyRefuseReason = verifyRefuseReason
  }
  get reverifyRefuseReason() {
    return this._data.reverifyRefuseReason
  }
  set reverifyRefuseReason(reverifyRefuseReason) {
    this._data.reverifyRefuseReason = reverifyRefuseReason
  }

  // ==================== 关联表信息 ====================
  get address() { // 收发通信息
    return this._data.address
  }
  set address(address) {
    this._data.address = address
  }
  get goods() { // 箱货信息
    return this._data.goods
  }
  set goods(goods) {
    this._data.goods = goods
  }
}
